import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../mockData';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 md:py-32 bg-white" data-testid="testimonials-section">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="max-w-2xl mb-20">
          <span className="text-xs tracking-[0.2em] uppercase text-stone-500 font-medium" data-testid="testimonials-label">
            Testemunhos
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-stone-900 mt-4 leading-tight italic font-serif uppercase tracking-tight" data-testid="testimonials-title">
            Os nossos clientes
          </h2>
          <p className="text-sm text-stone-500 mt-6 font-light italic">
            Comentários reais de clientes da RE/MAX Platina · Portimão
          </p>
        </div>

        {/* Testimonials - minimal columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="border-t border-stone-200 pt-8"
              data-testid={`testimonial-${index}`}
            >
              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-stone-900 text-stone-900" />
                ))}
              </div>

              {/* Text */}
              <p className="text-stone-700 leading-relaxed font-light mb-8 text-[15px] italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="pt-6 border-t border-stone-100">
                <div className="text-sm italic font-serif text-stone-900 tracking-tight">{testimonial.name}</div>
                <div className="text-[10px] uppercase text-stone-500 mt-2 tracking-[0.2em]">{testimonial.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
